
export const combinationOCXO1 = {
  frequencyInput: {
    type: "input", //or select
    array: [8,300] //if inputs min..max 2 items, select -> [8,10,20] for xbo25
  },
  temperatureRanges: [
    { code: "5", range: "0..50ºC" },
    { code: "6", range: "-10..60ºC" },
    { code: "7", range: "-30..70ºC" },
    { code: "8", range: "-40..80ºC" },
    { code: "9", range: "-40..85ºC" },
    { code: "C", range: "Custom" }
  ],
  supplySignalTypes: [
    { value: "hcmos3p3V", label: "HCMOS 3.3V" },
    { value: "hcmos5V", label: "HCMOS 5V" },
    { value: "sWave3p3V", label: "Sine 3.3V" },
    { value: "sWave5V", label: "Sine 5V" },
  ],
  signalTypes: [
    { code: "HCMOS", value: "HCMOS", label: "HCMOS" },
    { code: "Sine", value: "Sine", label: "Sine Wave" },
  ],
  supplyTypes: [
    { voltage: "3.3V", value: "3.3V" },
    { voltage: "5V", value: "5V" }
  ],
  agingOptions: [
    { code: "29", ppbPerDay: "2" },
    { code: "50", ppbPerDay: "0.5" },
    { code: "20", ppbPerDay: "0.2" },
    { code: "10", ppbPerDay: "0.1" },
    { code: "05", ppbPerDay: "0.05" },
    { code: "03", ppbPerDay: "0.03" }
  ],
  stabilityOptions: [
    { code: "50", value: "0.5", unit: "ppb" },
    { code: "19", value: "1", unit: "ppb" },
    { code: "29", value: "2", unit: "ppb" },
    { code: "39", value: "3", unit: "ppb" },
    { code: "59", value: "5", unit: "ppb" },
    { code: "18", value: "10", unit: "ppb" },
    { code: "28", value: "20", unit: "ppb" },
    { code: "38", value: "30", unit: "ppb" },
    { code: "58", value: "50", unit: "ppb" }
  ]
  
}
